(() => {
  const update = () => {
    const intro = document.querySelector('[data-lf-led-intro]');
    const launch = document.querySelector('#MainContent gravure-quote-3d[data-model="led-sign"] [data-launch]');
    if (intro && launch && intro.dataset.ledButtonLabel) launch.textContent = intro.dataset.ledButtonLabel;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:block:select', update);
})();
